import { isEmpty } from '@hprofits/utils/fp/optional';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

type ParseSchema<TId> = {
  safeParse: (value: unknown) => { success: true; data: TId } | { success: false };
};

const parseParam = <T>(value: unknown, schema: ParseSchema<T>): T | null => {
  if (isEmpty(value)) {
    return null;
  }
  // Route params arrive as strings; the numeric branded id schemas (z.int()) do
  // not coerce, so convert first — mirrors the pre-refactor safeParse(Number(token)).
  const parsed = schema.safeParse(Number(value));
  return parsed.success ? parsed.data : null;
};

export const useRouteParam = <T>(param: string, schema: ParseSchema<T>) => {
  const route = useRoute();
  return computed(() => parseParam(route.params[param], schema));
};
